module.exports = __webpack_public_path__ + "static/media/categories_step_2_4.c1613161.svg";